export default function isPascalCase(str: string): boolean {
  return /^[A-Z][a-z]*([A-Z][a-z]*)*$/.test(str);
}
